// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { loginUser, getSocialUrls } from '../../actions';
import Form from '../../ui/components/Forms/Login';

type Props = {
    clientID: string,
    social: Array<Object>,
    auth: {
        isLoadingButton: boolean,
    },
    language: string,
    branding: Object,
    params: Object,
    loginErrorMsg: string,
    branding: Object,
    loginUser: Function,
    changeForm: Function,
    getSocialUrls: Function,
};

type State = {
    name: String,
    active: Boolean,
};

export class Login extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            active: false,
        };
    }

    componentDidMount() {
        this.props.getSocialUrls();
    }

    loginUser = ({ email, password }: Object) => {
        if (this.props.auth.isLoadingButton) return;

        this.props.loginUser(email, password, this.props.clientID);
    };

    handleFocus = e => {
        e.preventDefault();
        this.setState({
            name: e.target.name,
            active: !this.state.active,
        });
    };

    render() {
        const {
            submitting,
            error,
            changeForm,
            auth,
            branding,
            params,
        } = this.props;

        return (
            <Form
                onSubmit={this.loginUser}
                changeForm={this.props.changeForm}
                social={this.props.social}
                branding={branding}
                params={params}
                handleFocus={this.handleFocus}
                active={this.state.active}
                name={this.state.name}
                lng={this.props.language}
                loginErrorMsg={this.props.loginErrorMsg}
                isLoading={auth.isLoadingButton}
            />
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        clientID: state.paywall.clientID,
        social: state.auth.socialUrls,
        auth: state.auth,
        branding: state.branding,
        params: state.form.loginForm,
        loginErrorMsg: state.auth.loginErrorMsg,
        language: state.auth.language,
    };
};

export default connect(
    mapStateToProps,
    {
        loginUser,
        getSocialUrls,
    }
)(Login);



// WEBPACK FOOTER //
// ./src/containers/Forms/Login.js